import { ISlotConverter } from '../../types/converter';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IGetGameUrl } from '../../types/slot';
import { CasinoType } from 'modules/Casino/types/configuration';
import horsePNG from './img/horse.png';

class Converter implements ISlotConverter {
  convertGameList = (): ISlotViewItem[] => [
    {
      id: 'game',
      gameId: 'game',
      description: 'game',
      gameName: 'Horse races',
      tab: [],
      provider: 'universalRace',
      imageUrl: horsePNG,
      routeProvider: 'universalRace',
      system: 'html',
      type: CasinoType.slots,
    },
  ];

  convertGameUrl = ({ data }: IGetGameUrl<{ game_url: string }, unknown>) => data.game_url;
}

export default Converter;
